<div class="carousel" style="--liCount: {{liCount}};--liHeight: {{liHeight}};--speed: {{ncTime}};--row: {{ncRow}};">
    <ng-content></ng-content>
</div>